var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"align":"center","cols":"10"}},[_c('v-sheet',{attrs:{"align":"start","color":"transparent"}},[_c('h1',{staticClass:"text-h3 my-2 font-weight-light"},[_vm._v("404")]),_vm._v(" foobar ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }